import React, { useState } from 'react';
import { Analytics } from '@vercel/analytics/react';
import Navigation from './components/Navigation';
import Introduction from './pages/Introduction';
import HowToUse from './pages/HowToUse';
import RiskAssessmentTool from './pages/RiskAssessmentTool';

const App = () => {
  const [currentPage, setCurrentPage] = useState('introduction');

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'introduction':
        return <Introduction />;
      case 'howto':
        return <HowToUse />;
      case 'tool':
        return <RiskAssessmentTool />;
      default:
        return <Introduction />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-7xl mx-auto">
        <header className="bg-gradient-to-r from-blue-50 to-indigo-50 shadow-lg rounded-lg p-6 mb-8">
          <div className="flex justify-between items-start">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2">
                NIS2 Cyber Risk Assessment Tool
              </h1>
              <p className="text-gray-600">
                Cyber Fundamentals Assurance Level Assessment for NIS2 Compliance
              </p>
            </div>
            <div className="flex-shrink-0">
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-200">
                <img 
                  src="https://cdn.prod.website-files.com/6788e2dd8dc04f8c75b681c7/67a9bac6dd4f6146ce4ea9d3_74ed7a5af022120ece3c974f67a1a050_logo-cycubix-dark.svg" 
                  alt="Cycubix Logo" 
                  className="h-10 w-auto"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <div className="text-right text-gray-500 text-sm font-medium hidden">
                  CYCUBIX
                </div>
              </div>
            </div>
          </div>
        </header>

        <Navigation currentPage={currentPage} setCurrentPage={setCurrentPage} />
        
        {renderCurrentPage()}

        {/* CyFun Framework Disclaimer */}
        <footer className="mt-16 pt-8 border-t-2 border-gray-300">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-8 shadow-sm">
            <div className="text-sm text-gray-800 leading-relaxed space-y-3">
              <h3 className="text-lg font-bold text-blue-900 mb-4">CyFun® Framework Disclaimer</h3>
              <p>
                The CyFun® Framework is a framework owned by the Centre for Cybersecurity Belgium (CCB),
                operating under the authority of the Prime Minister of Belgium.
              </p>
              <p>
                The abbreviation "CyFun®" stands for "CyberFundamentals Framework" and is a registered
                trademark owned by the CCB.
              </p>
              <p>
                The CyFun® Framework and CyFun® Conformity Assessment Scheme (CAS) are available on{' '}
                <a href="https://www.cyfun.eu" target="_blank" rel="noopener noreferrer"
                   className="text-blue-600 hover:text-blue-800 underline">
                  www.cyfun.eu
                </a>, which is their only authentic source.
              </p>
              <p>
                The services offered by Cycubix LTD may contribute to third party assessments, but they do
                not replace nor fulfill any accredited third-party assessment as described by the CyFun®
                Framework. Therefore, Cycubix LTD can never claim that its services fully meet the
                requirements of the CyFun® Framework and the services cannot be considered for use in
                conformity assessments resulting in obtaining a presumption of conformity with the NIS2
                Directive and its Belgian transposition.
              </p>
              <p>
                If there is any discrepancy between the products and services offered by Cycubix LTD and the
                documents on the website, only the latest version of the documents on the website is deemed
                authentic.
              </p>
            </div>
          </div>
        </footer>
      </div>
      <Analytics />
    </div>
  );
};

export default App;